import { useTranslation } from 'react-i18next';

import PrizeForm from './PrizeForm.jsx';
import BoxMessage from './BoxMessage.jsx';
import UserPreview from './userPreview.jsx';
import { Button } from '../../../shared/FormStyles';
import {
  FormWrapper,
  FormSection,
  Container,
  Footer,
} from './StyledComponents';
import usePrizeForm from './usePrizeForm';

function FormActions({ isValid, onStart, onSaveDraft, values }) {
  const { t } = useTranslation('prizes');

  return (
    <Footer>
      <Button
        variant="tertiary"
        disabled={!isValid}
        onClick={() => onSaveDraft(values)}
      >
        {t('setUp.saveDraft')}
      </Button>
      <Button
        mt="12px"
        variant="containedBlue"
        disabled={!isValid}
        onClick={() => onStart(values)}
      >
        {t('setUp.start')}
      </Button>
    </Footer>
  );
}

const SetUp = ({ raffle }) => {
  const { t } = useTranslation('prizes');

  const { onSaveDraft, onStart, values, isValid, ...form } = usePrizeForm({
    prizeValues: raffle,
  });

  return (
    <FormWrapper>
      <FormSection>
        <BoxMessage
          title={t('prizes:setUp.titleBox')}
          message={t('prizes:setUp.messageBox')}
          link="http://learning.airbo.com/en/articles/1045109-how-to-add-a-prize"
          linkText={t('prizes:setUp.linkText')}
        />
        <Container>
          <PrizeForm isShow={false} values={values} {...form} />
          <FormActions
            isValid={isValid}
            values={values}
            onStart={onStart}
            onSaveDraft={onSaveDraft}
          />
        </Container>
      </FormSection>
      <UserPreview raffle={values} />
    </FormWrapper>
  );
};

export default SetUp;
